import { isArray } from "lodash-es";

export const translation = (list, data, value = "value", label = "label") => {
  let translate = "";
  if (isArray(data)) {
    data.map((dataItem, idx) => {
      const temp = list.find((item) => String(item[value]) === String(dataItem));
      if (temp && temp[label]) {
        translate += `${idx > 0 ? ", " : " "}${temp[label]}`;
      }
      return translate;
    });
  } else {
    const result = list.find((item) => String(item[value]) === String(data));
    translate = result ? result[label] : data;
  }
  return translate;
};